module.exports = __webpack_public_path__ + "img/manual6.5a733ca8.png";